import React from 'react';
import { GripVertical, X } from 'lucide-react';
interface EditorCard {
  id: string;
  title: string;
  url: string;
  description: string;
  image: string;
  enabled: boolean;
  price?: string;
  status?: string;
}
interface CardItemProps {
  card: EditorCard;
  sectionType: 'listings-videos' | 'custom-links';
  onUpdate: (id: string, updates: Partial<EditorCard>) => void;
  onDelete: (id: string) => void;
  onDragStart: (e: React.DragEvent, cardId: string) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, targetCardId: string) => void;
  isDragging: boolean;
}
export function CardItem({
  card,
  sectionType,
  onUpdate,
  onDelete,
  onDragStart,
  onDragOver,
  onDrop,
  isDragging
}: CardItemProps) {
  return <div draggable onDragStart={e => onDragStart(e, card.id)} onDragOver={onDragOver} onDrop={e => onDrop(e, card.id)} className={`flex items-start gap-3 p-4 bg-white border border-brand-light rounded-xl shadow-sm group transition-all ${isDragging ? 'opacity-50' : ''}`} data-id="element-49">
      <button type="button" className="mt-2 text-brand-light group-hover:text-brand-muted cursor-grab active:cursor-grabbing transition-colors" data-id="element-50">
        <GripVertical size={18} data-id="element-51" />
      </button>

      {card.image && <div className="w-16 h-16 rounded-lg overflow-hidden shrink-0 bg-brand-light" data-id="element-52">
          <img src={card.image} alt={card.title} className="w-full h-full object-cover" data-id="element-53" />
        </div>}

      <div className="flex-1 space-y-2 min-w-0" data-id="element-54">
        <input type="text" value={card.title} onChange={e => onUpdate(card.id, {
        title: e.target.value
      })} className="w-full font-medium text-brand-dark outline-none border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors" placeholder="Title" data-id="element-55" />
        <input type="text" value={card.url} onChange={e => onUpdate(card.id, {
        url: e.target.value
      })} className="w-full text-sm text-brand-muted outline-none border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors font-mono" placeholder="URL" data-id="element-56" />
        <input type="text" value={card.description} onChange={e => onUpdate(card.id, {
        description: e.target.value
      })} className="w-full text-sm text-brand-muted outline-none border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors" placeholder="Description" data-id="element-57" />

        {sectionType === 'listings-videos' && <div className="flex items-center gap-2 pt-1" data-id="element-58">
            {card.price && <input type="text" value={card.price} onChange={e => onUpdate(card.id, {
          price: e.target.value
        })} className="w-24 text-sm font-mono font-medium text-brand-dark outline-none border-b border-transparent hover:border-brand-light focus:border-brand-forest transition-colors" placeholder="Price" data-id="element-59" />}
            {card.status && <span className="text-[10px] font-medium px-2 py-0.5 rounded-full border bg-emerald-50 text-emerald-700 border-emerald-200" data-id="element-60">
                {card.status}
              </span>}
          </div>}
      </div>

      <div className="flex items-center gap-2 shrink-0" data-id="element-61">
        <button type="button" className={`w-10 h-6 rounded-full transition-colors relative ${card.enabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => onUpdate(card.id, {
        enabled: !card.enabled
      })} data-id="element-62">
          <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${card.enabled ? 'left-5' : 'left-1'}`} data-id="element-63"></div>
        </button>
        <button type="button" onClick={() => onDelete(card.id)} className="p-1.5 text-brand-muted hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors" data-id="element-64">
          <X size={16} data-id="element-65" />
        </button>
      </div>
    </div>;
}